import type { ReactNode } from 'react';

/**
 * English content inside a translated screen (spec §3.1): a screen reader
 * switches voice, and an RTL page does not reorder "I went home" under the
 * bidi algorithm. Inline, so the island sits where the page's direction puts it
 * and only reads left to right inside.
 */
export function En({ children }: { children: ReactNode }) {
  return (
    <span lang="en" dir="ltr">
      {children}
    </span>
  );
}
